require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-13-examples-of-minimal-e-commerce-web-design-to-inspire-you.json") })
        }
      }, "path---blog-13-examples-of-minimal-e-commerce-web-design-to-inspire-you");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-13-examples-of-minimal-e-commerce-web-design-to-inspire-you!./.cache/json/blog-13-examples-of-minimal-e-commerce-web-design-to-inspire-you.json
// module id = 382
// module chunks = 231608221292675